import { defineComponent as _defineComponent } from 'vue'
import { format } from 'date-fns';
import { computed } from 'vue';
import IconTimer from '@white-label-icon/icon-timer';

import { CART_REVALIDATION_INTERVAL } from '@white-label-configuration/constants';

interface Props {
  secondsUntilExpired: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'payment-page-countdown',
  props: {
    secondsUntilExpired: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { secondsUntilExpired: number };



const secondsToMinutes = computed(() =>
  format(new Date(props.secondsUntilExpired * 1000), 'mm:ss')
);

const progressPercent = computed(() => {
  const value =
    ((CART_REVALIDATION_INTERVAL - props.secondsUntilExpired) /
      CART_REVALIDATION_INTERVAL) *
    100;
  return Math.min(Math.max(value, 0), 100);
});

return { __sfc: true,props, secondsToMinutes, progressPercent, IconTimer }
}

})